import type { EntityDetailSchemaWithRelationships } from '@web-config-app/core';
import { getRelationshipSchemaItemType } from '@web-config-app/schema-utils';
import { RelationshipValue } from '../../types/controls';

export const getCreateRelationshipValueFromSchema = (
  relationship: string,
  schema: EntityDetailSchemaWithRelationships,
  type?: string,
) => {
  const { type: schemaRelationshipType } = getRelationshipSchemaItemType(
    relationship,
    schema,
  );
  return function createRelationshipValue({ id }: Partial<RelationshipValue>) {
    return {
      id,
      type: type ?? schemaRelationshipType,
    };
  };
};
